import { CheckCircle2, ChevronLeft, Mic, Utensils, BarChart3 } from 'lucide-react';
import { progress, type DemoScene } from './demoScenario';
import { FocusTrace } from './FocusTrace';

type Props = { scene: DemoScene; time: number; still: boolean };
export function VoiceDemoScreen(props: Props) {
  const { scene, time, still } = props;
  const editing = scene.screen === 'voice-edit';
  const entry = scene.screen === 'voice-entry';
  const phrase = editing ? 'Actually, three eggs, and add butter to the toast.' : 'I had two eggs and a slice of toast.';
  const spoken = still ? phrase.length : Math.floor(progress(time, scene.start + 650, 2600) * phrase.length);
  if (entry) return <div className="nd-native-body nd-editor">
    <div className="nd-editor-top"><div className="nd-back"><ChevronLeft /></div><span>Today • 08:15</span></div>
    <h3>Eggs and toast</h3>
    <div className="nd-period nd-editor-tabs"><span><Utensils /> Meal</span><span><BarChart3 /> Nutrients</span></div>
    <FocusTrace {...props} target="voice-change" className="nd-secondary-action"><Mic /> Change anything</FocusTrace>
    <div className="nd-card nd-voice-meal"><h4>Food</h4>
      <div><strong>Eggs</strong><span>{scene.complete ? '3 eggs' : '2 eggs'}</span></div>
      <div><strong>Toast</strong><span>1 slice</span></div>
      {scene.complete && <div className="nd-voice-corrected"><strong>Butter</strong><span>10 g</span></div>}
    </div>
    <div className="nd-voice-saved"><CheckCircle2 />{scene.complete ? 'Meal updated' : 'Added to Food Log'}</div>
    {scene.complete && <p className="nd-voice-note">Three eggs. Butter added.<br />Your nutrients are updated, too.</p>}
  </div>;
  return <><div className="nd-native-header"><div className="nd-back"><ChevronLeft /></div><h3>{editing ? 'Change anything' : 'Voice Mode'}</h3></div>
    <div className="nd-deep-body nd-voice-demo-body">
      <div className="nd-card nd-voice-demo-context"><strong>{editing ? 'Eggs and toast' : 'What did you eat?'}</strong><p>{editing ? 'Tell Nomsy what to change.' : 'Just describe your meal.'}</p></div>
      <div className="nd-card nd-voice-recording"><span className="nd-voice-listening">{spoken < phrase.length ? 'Listening…' : 'Ready to save'}</span><p>“{phrase.slice(0, spoken)}”</p>
        <div className="nd-voice-wave" aria-hidden="true">{Array.from({ length: 17 }, (_, i) => <i key={i} style={{ height: `${8 + (still ? 4 : (Math.sin(time / (spoken === phrase.length ? 340 : 170) + i * 1.9) + 1) * (spoken === phrase.length ? 5 : 13))}px` }} />)}</div>
        <div className="nd-mic"><Mic /></div>
      </div>
    </div>
    <div className="nd-bottom-action"><FocusTrace {...props} target="send" className="nd-primary-action">{editing ? 'Save Changes' : 'Add Meal'}</FocusTrace></div>
  </>;
}
